// A speech bubble beside the sidebar: the theme's background, border and
// text colors (Server settings > Themes, Custom theme), and the 4px corners
// of the search box

.bubble {
  z-index: 9999;
  box-sizing: border-box;
  width: 280px;
  max-width: calc(100vw - 16px);
  padding: 6px;
  border: 1px solid var(--color-border-primary);
  border-radius: 4px;
  background: var(--color-bg-primary);

  // Half of Mastodon's dropdown shadow (rounded down)
  box-shadow:
    0 10px 12px -2px var(--color-shadow-primary),
    0 4px 5px -3px var(--color-shadow-primary);
  color: var(--color-text-primary);
}

// For screen readers; the bubble points at "Switch account" already
.title {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.add {
  display: block;
  width: 100%;
  margin-top: 6px;
  padding: 10px 8px 6px;
  border: 0;
  border-top: 1px solid var(--color-border-primary);
  background: transparent;

  // Like the buttons of a column's title bar: the accent color, fainter
  // on hover
  color: var(--color-text-brand);
  font: inherit;
  font-size: var(--theme-handle-size, 13px);
  font-weight: 600;
  text-align: start;
  cursor: pointer;

  &:hover:not(:disabled),
  &:focus-visible {
    opacity: 0.75;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
}

// The point of the bubble: a square turned 45°, bordered on its two outer
// sides, half of it under the bubble's edge
.arrow {
  position: absolute;
  width: 12px;
  height: 12px;
  background: var(--color-bg-primary);
  border: 1px solid transparent;
  transform: rotate(45deg);
}

.arrow-right {
  border-bottom-color: var(--color-border-primary);
  border-left-color: var(--color-border-primary);
}

.arrow-left {
  border-top-color: var(--color-border-primary);
  border-right-color: var(--color-border-primary);
}

.arrow-bottom {
  border-top-color: var(--color-border-primary);
  border-left-color: var(--color-border-primary);
}

.arrow-top {
  border-bottom-color: var(--color-border-primary);
  border-right-color: var(--color-border-primary);
}

// The icon and words of the sidebar item, which the bubble points at
.label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
